<script lang="ts">
  import { onMount } from "svelte";
  import { ApiService } from "../../services/api.service";
  import BlueButton from "../BlueButton.svelte";

  import FormWithLabel from "../../molecules/FormWithLabel.svelte";
  import SectionBoard from "../../molecules/SectionBoard.svelte";

  let loading = false;

  let entry = "";
  let blog = "";

  const handleEntry = (event) => {
    entry = event.detail.value;
  };

  const handleBlog = (event) => {
    blog = event.detail.value;
  };

  onMount(async () => {
    const client = ApiService.createClient();
    const { data } = await client.get("/links");

    entry = data.links.entry;
    blog = data.links.blog;
    console.log(data.links);
  });

  const save = async () => {
    const client = ApiService.createClient();
    loading = true;
    const promises = [
      client.post("/links", {
        category: "entry",
        name: "エントリー",
        url: entry,
      }),

      client.post("/links", {
        category: "blog",
        name: "ブログ",
        url: blog,
      }),
    ];

    await Promise.all(promises);
    loading = false;
  };
</script>

<SectionBoard>
  <h2 class="font-semibold">リンク設定</h2>

  <div class="mt-6">
    <FormWithLabel
      label="エントリー"
      placeholder=""
      input={handleEntry}
      value={entry}
    />
  </div>

  <div class="mt-6">
    <FormWithLabel
      label="ブログ"
      placeholder=""
      input={handleBlog}
      value={blog}
    />
  </div>

  <BlueButton rounded klass="mt-4" click={save} {loading}>更新する</BlueButton>
</SectionBoard>
